<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      list: [{
        title: 'Mojito',
        artist: '周杰伦',
        src: 'https://echobot.club/group1/M00/00/00/CgAUBmJH8fqADvlTAU6qKC1l3oY65.flac',
        pic: 'https://y.qq.com/music/photo_new/T002R300x300M0000009C3rp3Kfwg0_3.jpg?max_age=2592000'
      }, {
        title: '据说真的有神',
        artist: '木秦',
        src: 'https://echobot.club/group1/M00/00/00/r7JWxWJIrAqAaTzcAGQkWBN88Fw035.mp3',
        pic: 'http://p2.music.126.net/wDf7j_zUmCRQ3Iri4usJ4A==/109951163074572687.jpg?param=130y130'
      }, {
        title: '50 Feet',
        artist: 'SoMo',
        src: 'https://echobot.club/group1/M00/00/00/r7JWxWJIq8eAUt6sAHJng40_PVg625.mp3',
        pic: 'http://p2.music.126.net/-uGrdpcVwLIMEx6NXGaNrQ==/109951163168473869.jpg?param=130y130'
      }]
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar'
    ]),
    /* routes() {
      return this.$router.options.routes
    }, */
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
